<div class="company-outer-box py-3 mt-5">
	<div>
		<h3 class="fs-24px fw-500 fg-black mb-4">{{ pageData.title }}</h3>
		<div class="fs-14px fw-400 lh-22px my-4">
			<span *ngIf="viewport.type !== 'mobile'" class="mb-1">{{ pageData?.content1 }}</span>
			<p *ngIf="viewport.type === 'mobile'" class="mb-1">{{ pageData?.content1 }}</p>

			<span *ngIf="pageData?.websiteLink" class="my-3">
				&#40;
				<a href="{{ pageData['websiteLink'] }}">{{ pageData['websiteLink'] }}</a>
				&#41;,

				<span>{{ pageData['content2'] }}</span>

				<p class="my-3">{{ pageData['content3'] }}</p>
			</span>

			<div *ngIf="pageData?.mailTo" class="my-3">
				<span class="me-1">{{ pageData['content2'] }}</span>

				<a href="mailto:hello@kurdshopping.com">{{ pageData['mailTo'] }}</a>

				<span class="ms-1">{{ pageData['content3'] }}</span>
			</div>

			<p class="my-3">{{ pageData['readText'] }}</p>
		</div>

		<button mat-stroked-button class="btn-border fw-400 pdf-button" color="primary" (click)="openPdf(pageData['pdfLink'])">
			{{ pageData.buttonText }}
		</button>
	</div>
</div>
